module.exports = __webpack_public_path__ + "img/education1.b985ddea.svg";